import { Api, ModerApi } from "./Api";
import Csrf from "./Csrf";
import Cookie from "js-cookie";

export default {
  async registerClient(form)
  {
    await Csrf.getCookie();

    return Api.post("/auth/client/register", form, {
      headers: {
        client: null
      }
    });
  },

  async registerUser(form)
  {
    await Csrf.getCookie();

    return Api.post("/auth/user/register", form, {
      headers: {
        client: null
      }
    });
  },

  async login(form)
  {
    await Csrf.getCookie();

    return Api.post("/auth/user/login", form);
  },

  loginToUser(userId)
  {
    Csrf.getCookie();
    
    return Api.post(`/auth/moder/loginToUser?user_id=${userId}`);
  },

  async logout()
  {
    await Csrf.getCookie();

    return Api.post("/auth/user/logout");
  },

  async logoutFromUser(id)
  {
    // TODO:  
    // 1. api request moderToUser
    // 2. if 200 to logout current session
    // 3. login by await Csrf.getCookie();
    // 4. test session user()
    //Csrf.getCookie();

    return Api.post(`/auth/moder/backToModer/${id}`);
  },

  async auth()
  {
    await Csrf.getCookie();

    return Api.get("/auth/user/info");
  },

  changePassword(obj)
  {
    let { email, oldPassword, newPassword, newPasswordConfirmation } = obj;

    return Api.get(`/auth/user/change-password?email=${email}&old_password=${oldPassword}&new_password=${newPassword}&new_password_confirmation=${newPasswordConfirmation}`);
  }
};
